<template>
  <nav
    v-if="breadcrumbs.length"
    class="is-flex align-center breadcrumb-container"
  >
    <div
      v-for="(crumb, index) in breadcrumbs"
      :key="index"
      class="breadcumb-links"
    >
      <router-link
        :to="getLink(crumb)"
        :class="{'router-link-exact-active': isActiveLink(crumb)}"
        class="breadcrumb-item"
      >
        {{ getLabel(crumb) }}
      </router-link>
      <span
        v-show="index !== breadcrumbs.length -1 "
        class="has-margin-horizontal-1"
      >/
      </span>
    </div>
  </nav>
</template>

<script>


export default {
  name: 'Breadcrumb',
  computed: {
    // Vue 3: vue-breadcrumbs ($breadcrumbs) rimosso → ricostruito da
    // `$route.matched` filtrando i record con `meta.breadcrumb` (stessa
    // semantica del plugin). In naviga-web nessuna rotta definisce
    // `meta.breadcrumb`, quindi l'array resta vuoto come nell'originale.
    breadcrumbs() {
      return this.$route.matched.filter(record => record.meta && record.meta.breadcrumb);
    },
  },
  methods: {
    getLabel(crumb) {
      return crumb.meta.detail || crumb.meta.index ?
        crumb.meta.routeLabel : this.$t(crumb.meta.breadcrumb.name);
    },
    getLink(crumb) {
      if (crumb.name || (crumb.handler && crumb.handler.name)) {
        return {
          name: crumb.name || crumb.handler.name,
          params: this.$route.params,
        };
      }

      return {
        path: crumb.handler && crumb.handler.fullPath ? crumb.handler.fullPath : crumb.path,
        params: this.$route.params,
      };
    },
    isActiveLink(crumb) {
      return crumb.name === this.$route.name;
    },
    isChangeableCustomer(crumb) {
      if (crumb.meta.index && crumb.meta.index === 'insertedOffers') {
        return true;
      }
      if (crumb.meta.index && crumb.meta.index === 'insertedOrders') {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss">

.breadcrumb-container{
  .breadcumb-links{
    color: $grey-gull;
  }

  .breadcrumb-item {
    font-size: $size-9;
    color: $grey-gull;
  }

  .breadcrumb-item.router-link-exact-active{
    font-size: $size-7;
    color: $blue-calypso;
  }
}

</style>
